/**
 * Why a session ended. Rides on the 'Sign Out' Mixpanel event as `trigger`,
 * which is what makes the deliberate-versus-forced split queryable — 'Open user
 * menu' is autocaptured rather than tracked, so it can't stand in as a proxy.
 * Route every call site through these constants so a typo can't silently split
 * one trigger into two values in the Mixpanel breakdown.
 */
export const SIGN_OUT_TRIGGERS = {
  // They clicked Sign out.
  USER_MENU: 'user_menu',
  // The server rejected the session (401/403) on GET /user, or getToken() did.
  AUTH_FAILURE: 'auth_failure',
  // Syncing a fresh login to our backend was rejected (401/403).
  ADD_USER_FAILURE: 'add_user_failure',
};
